import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { NotificationStoreService, DatastoreService } from '../../../services';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
	color = '';
	background = '';
	logo = '';
	urlLink = '';
	footerText = '';
	socialLinks: any[] = [];
	footerLinks: any[] = [];

	constructor(
		private notifStore: NotificationStoreService,
		private dataStore: DatastoreService,
		private renderer2: Renderer2,
		@Inject(DOCUMENT) private document2: Document
	) {}

	ngOnInit(): void {
		// subscribe to session updates for config changes
		this.notifStore.sessionUpdate.subscribe(() => {
			this.loadConfig();
		});
		this.loadConfig();
	}

	loadConfig() {
		const config = this.dataStore.config;
		if (config) {
			const configJson = JSON.parse(config);
			this.color = configJson.text_colour;
			this.background = configJson.footer_colour;
			this.footerText = configJson.footer_text;
			this.logo = configJson.logo;
			this.urlLink = configJson.logo_link;
			console.log(configJson.myCeremony.footer.socials);
			if (configJson.hasOwnProperty('myCeremony')) {
				if (configJson.myCeremony.hasOwnProperty('footer')) {
					if (configJson.myCeremony.footer.hasOwnProperty('socials')) {
						if (configJson.myCeremony.footer.socials.length > 0) {
							for (const social of configJson.myCeremony.footer.socials) {
								this.socialLinks.push(social);
							}
						}
					}

					if (configJson.myCeremony.footer.hasOwnProperty('links')) {
						if (configJson.myCeremony.footer.links.length > 0) {
							for (const link of configJson.myCeremony.footer.links) {
								this.footerLinks.push(link);
							}
						}
					}
				}
			}
		}
	}
}
